import { useState, useEffect, useCallback, useRef } from 'react'
import { getSubmit } from 'ui-seeker/utils'

import { BANNER } from 'app/@common/constants'

export default function useBannerMessages() {
    const [messages, setMessages] = useState([])
    const mounted = useRef(true)

    const loadMessages = useCallback(() => {
        getSubmit(BANNER.MESSAGES)
            .then(data => {
                if (mounted.current) setMessages(data || [])
            })
            .catch(() => {
                if (mounted.current) setMessages([])
            })
    }, [])

    useEffect(() => {
        mounted.current = true
        loadMessages()
        return () => { mounted.current = false }
    }, [loadMessages])

    return { messages }
}
